<div class="screen">

  <div class="network-pulse">
    <p class="network-label">{{ 'mobileSimulator.reseau.groupSites' | translate: { count: sites.length } }}</p>
    <div class="network-chips">
      <button class="nc-chip nc-chip--critical" [class.nc-active]="activeFilter() === 'critique'" (click)="setFilter('critique')">
        <span class="nc-dot"></span>{{ 'mobileSimulator.reseau.filterCritique' | translate }}
      </button>
      <button class="nc-chip nc-chip--moderee" [class.nc-active]="activeFilter() === 'moderee'" (click)="setFilter('moderee')">
        <span class="nc-dot"></span>{{ 'mobileSimulator.reseau.filterModeree' | translate }}
      </button>
      <button class="nc-chip nc-chip--fluide" [class.nc-active]="activeFilter() === 'fluide'" (click)="setFilter('fluide')">
        <span class="nc-dot"></span>{{ 'mobileSimulator.reseau.filterFluide' | translate }}
      </button>
    </div>
  </div>

  @for (site of filteredSites(); track site.id) {
    <div class="site-card" [attr.data-status]="site.statut" (click)="siteSelected.emit(site)">

      <!-- ── Nom pleine largeur au-dessus des colonnes ── -->
      <div class="card-top">
        <span class="site-dot" [attr.data-status]="site.statut"></span>
        <span class="site-name">{{ site.nom }}</span>
      </div>

      <!-- ── Deux colonnes ── -->
      <div class="card-body">

        <div class="card-left">
          <span class="meta-tension" [attr.data-status]="site.statut">{{ site.tensionLabel }}</span>

          @if (site.descInfo) {
            <span class="meta-desc">{{ site.descInfo }}</span>
          }

          @if (site.statut !== 'ferme') {
            <div class="card-chips">
              @for (alerte of site.alertes; track alerte.text) {
                <span class="chip" [attr.data-type]="alerte.type">{{ alerte.text }}</span>
              }
            </div>
          }
        </div>

        @if (site.statut !== 'ferme') {
          <div class="card-right" [attr.data-status]="site.statut">
            <span class="right-count">{{ site.presenceEstimee }}</span>
            <span class="right-lbl">{{ 'mobileSimulator.common.surSite' | translate }}</span>
            <span class="right-act" [attr.data-level]="site.activiteLevel">{{ site.activite }}</span>
            </div>
        }

      </div>

      @if (site.statut !== 'ferme') {
        <div class="card-timeline">
          @for (slot of getTimelineSlots(); track slot; let i = $index) {
            <div class="tl-col">
              <span class="tl-dot" [style.background]="tlColor(site.timeline[i])"></span>
              <span class="tl-time">{{ slot }}</span>
            </div>
          }
        </div>
      }

    </div>
  }

</div>